import React, { useState, useLayoutEffect } from 'react'
import { Grid, Typography, Box } from '@material-ui/core'
import pictoAccessLogoSrc from 'assets/images/pictoaccess-logo.png'
import Picture from '../../atoms/Picture'
import Link from '../../atoms/Link'
import useStyles from './styles'

const pictoAccessLogo = () => {
  let logo = pictoAccessLogoSrc
  if (process.env.NODE_ENV !== 'development') {
    const { widgetUrl } = document.querySelector('body').dataset
    logo = `${widgetUrl}${pictoAccessLogoSrc}`
  }
  return logo
}

const StoreLocatorWidget = ({ storeLocatorUrl, cardsCount, logo, name }) => {
  const [hover, setHover] = useState(false)
  const classes = useStyles({ hover })
  const [imgPicto, setImgPicto] = useState(null)

  useLayoutEffect(() => {
    setImgPicto(pictoAccessLogo())
  }, [imgPicto])

  return (
    <Grid
      tabIndex="-1"
      onClick={() => window.open(storeLocatorUrl)}
      className={classes.root}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      container
      direction="row"
      alignItems="center"
    >
      <Grid item xs={3} className={classes.pictureRoot}>
        <Picture src={logo.cropped_url} />
      </Grid>
      <Grid item xs className={classes.contentRoot}>
        <Typography variant="h1" gutterBottom={false} className={classes.title}>
          {name}
        </Typography>
        <Typography
          gutterBottom={false}
          className={classes.contentDetails}
          variant="h3"
        >
          {`Découvrez l'accessibilité de nos ${cardsCount} lieux`}
        </Typography>
        <Box className={classes.bottomContainer}>
          <Typography variant="h3" className={classes.linkLabel}>
            En savoir plus
          </Typography>
          <Link
            className={classes.pictoLogoLink}
            href={storeLocatorUrl}
            target="_blank"
          >
            {imgPicto && (
              <img
                className={classes.pictoLogo}
                src={imgPicto}
                alt="PictoAccess Logo"
              />
            )}
          </Link>
        </Box>
      </Grid>
    </Grid>
  )
}

export default StoreLocatorWidget
